module.exports = __webpack_public_path__ + "img/small-hero-1.2b8cda37.webp";